/** Fixed header height + breathing room so section titles stay visible */
const DEFAULT_OFFSET_PX = 96;

/**
 * Scroll so `element` sits below the fixed nav (uses scroll-margin-top when set).
 */
export function getAnchorScrollTop(element) {
  if (!element) return 0;
  const marginTop = parseFloat(window.getComputedStyle(element).scrollMarginTop);
  const offset = Number.isNaN(marginTop) || marginTop <= 0 ? DEFAULT_OFFSET_PX : marginTop;
  return Math.max(0, element.getBoundingClientRect().top + window.pageYOffset - offset);
}

export function scrollToAnchor(element, { behavior = 'smooth' } = {}) {
  const top = getAnchorScrollTop(element);
  window.scrollTo({ top, left: 0, behavior });
}
